import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  image: {
    marginTop: theme.spacing(1),
    width: 110,
    height: 110,
    borderRadius: 10,
  },
  avatar: {
    margin: [theme.spacing(2), 0],
  },
  companyLogo: {
    margin: [theme.spacing(2), 0],
  },
  companyLogoImage: {
    marginTop: theme.spacing(1),
    height: 'auto',
    width: 'auto',
    maxWidth: 150,
    maxHeight: 150,
  },
  field: {
    marginBottom: theme.spacing(2),
    width: '100%',
    '& fieldset': {
      borderColor: theme.palette.colors.border,
    },
    '& label': {
      position: 'relative',
      transform: 'none',
      fontSize: 12,
      marginBottom: theme.spacing(1),
      color: '#90A4AE',
    },
    '& input': {
      height: '100%',
      padding: [0, 14],
    },
    [theme.breakpoints.up('mobile')]: {
      width: 400,
    },
  },
  button: {
    width: '100%',
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('mobile')]: {
      width: 400,
    },
  },
  fields: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
  },
  loanOfficerInfoBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      marginRight: theme.spacing(4),
      width: 'unset',
    },
  },
  loanOfficerCompanyBox: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      width: 'unset',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/AdminLoanOfficer/components/LoanOfficerForm/useStyles.js